import React from 'react'
import _cx from 'classnames/bind'
import CopyButton from '../../elementals/copyButton'
import Icon from '../../elementals/icon'
import Animate from '../../elementals/animate'
import MarkdownWithComponents from '../../elementals/markdownWithComponents'
import type {
  MarkdownComponentAction,
  MarkdownComponentMap,
} from '../../elementals/markdownWithComponents/types'
import type { CognitionEvaluationChatOutputMessage } from '@adc/sdk/types'
import cls from './styles.scss'

const cx = _cx.bind(cls)

export interface CognitionChatOutputMessageProps {
  message: CognitionEvaluationChatOutputMessage
  index: number
  onCopy?: (content: string) => void
  onAction?: (action: MarkdownComponentAction) => void
  components?: MarkdownComponentMap
  showAssistantLabel?: boolean
  isVisible?: boolean
  elmId?: string
}

const CognitionChatOutputMessage: React.FC<CognitionChatOutputMessageProps> = ({
  message,
  index,
  onCopy,
  onAction,
  components,
  showAssistantLabel = true,
  isVisible = true,
  elmId = 'cognition_message',
}) => {
  return (
    <Animate.FadeInOut
      key={`${message.sequence}-model`}
      isVisible={isVisible}
      duration={500}
    >
      <div
        className={cx('message', 'ai')}
        data-elm-id={`${elmId}_container_${index}`}
      >
        {showAssistantLabel && (
          <div className={cx('assistant-label')}>
            <Icon
              name='sparkles'
              color='adc-light-blue'
              iconStyle='solid'
              style={{ fontSize: '1.2em' }}
            />
            <span>AI Assistant</span>
          </div>
        )}
        <div
          className={cx('message-bubble', 'ai')}
          data-elm-id={`${elmId}_bubble_${index}`}
        >
          <MarkdownWithComponents
            content={message.object?.message || ''}
            className={cx('message-content')}
            onAction={onAction}
            components={components}
            elmId={`${elmId}_content_${index}`}
          />
        </div>
        <div className={cx('message-actions')}>
          <CopyButton
            text={message.object?.message || ''}
            onCopy={onCopy}
            size='small'
            elmId={`${elmId}_copy_${index}`}
            showSuccessFeedback
            className={cx('extra-small-button')}
          />
        </div>
      </div>
    </Animate.FadeInOut>
  )
}

export default CognitionChatOutputMessage
